<template>
    <main class="page-main">
        <swiper v-show="preloader"
                :options="swiperOption"
                class="section-content content-info-page game-info-page"
                ref="contentSwiperJS"
                @slideChange="slideEvent"
                id="contentSwiperJS">
            <!-- slides -->
            <swiper-slide v-for="item in items" :key="item.id">
                <article>
                    <div class="content-wrapper">
                        <div class="content-inner clearfix">
                            <h2 v-if="item.properties.title">{{item.properties.title}}</h2>
                            <div class="content-item__teaser">
                                <img :data-src="media+ 'images/' + item.image" width="493" src="../assets/images/preloader493x361.gif" class="swiper-lazy"
                                     :alt="item.properties.title">
                                <div class="prev-slide"></div>
                                <div class="next-slide"></div>
                            </div>
                            <div class="content-item__info">
                                <div class="content-item__summary">
                                    <span>{{item.properties.genre}}</span>
                                </div>
                                <div v-if="item.properties.description" class="content-item__synopsis">
                                    <span>{{item.properties.description}}</span>
                                </div>
                                <div class="content-item__platforms"><i class="svg-inline plane-icon"></i><span>{{$t('avaiable')}}: {{item.airplane}}</span></div>
                            </div>
                            <div class="slide__options">
                                <a @click.prevent="backHelper" class="back-link">
                                    <svg class="svg-inline arrow-left-icon">
                                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-left"></use>
                                    </svg>
                                    {{$t('backToGames')}}</a>
                            </div>
                        </div>
                    </div>
                </article>
            </swiper-slide>
<!--            <div class="swiper-pagination" id="swiperPaging" slot="pagination"></div>-->

            <!-- Optional controls -->
            <div class="swiper-button-prev" id="swiperPrevBtn" slot="button-prev"></div>
            <div class="swiper-button-next" id="swiperNextBtn" slot="button-next"></div>
        </swiper>
    </main>
</template>

<script>
    let backLink = '/games';
    import { setDataID, setPrevNextTeasers, navPos } from '../outer-js'
    import { mapGetters } from 'vuex'
    export default {
        props:['id'],
        name: "GameInfo",
        data() {
            return {
                preloader:false,
                loading:true,
                items: false,
                backUrl:'/',
                media: process.env.VUE_APP_MEDIA,
                swiperOption:{
                    effect: 'fade',
                    centeredSlides: true,
                    autoHeight: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    setWrapperSize: true,
                    speed: 800,
                    preloadImages: false,
                    lazy: true,
                    loadOnTransitionStart: true,
                    loadPrevNextAmount: 3,
                    loadPrevNext: true,
                    pagination: {
                        el: '#swiperPaging',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '#swiperNextBtn',
                        prevEl: '#swiperPrevBtn'
                    },
                    fadeEffect: {
                        crossFade: true
                    },
                }
            }
        },
        computed:{
            ...mapGetters({
                lang: 'getLang',
                preview: 'getPreview',
            }),
            mySwiper(){
                return this.$refs.contentSwiperJS.swiper
            }
        },
        watch: {
            lang: function (oldVal, newVal) {
                if(newVal){
                    this.getSlides();
                }
            },
        },
        beforeRouteEnter: (to, from, next) => {
            backLink = from.fullPath;
            if (!from.name) {
                backLink = 'fromBackend';
            }
            next();
        },
        created(){
            this.getSlides();
        },
        mounted(){
            let img = document.querySelector('img');
            if (img.complete) {
                this.preloader = true;
            }
        },
        methods:{
            getSlides(){
                this.loading = true;
                this.axios.get(this.lang + '/info_page/'+ this.id + (this.preview ? ('?set=' + this.preview) : ''))
                    .then(response => {
                        this.items = response.data.data.items;
                        this.backUrl = this.items[0].backUrl;
                        this.loading = false;
                        this.$nextTick(() => {
                            setDataID('.info-slide', 'data-slide-id');
                            setPrevNextTeasers();
                            let img = window.document.querySelector('.preloader-game');
                            img.addEventListener("load", (e) => {
                                console.log(e);
                                this.preloader = true;
                            } );
                            if (img.complete) {
                                this.preloader = true;
                            }
                            this.initSlideOpt();
                        });
                    })
                    .catch(error =>{
                        console.log(error, error.response);
                        this.loading = true;
                    });
            },
            initSlideOpt(){
                window.dispatchEvent(new Event('resize'));
                let index = this.items.findIndex( item => item.id == this.id);
                this.mySwiper.slideTo(index);
                if (backLink === 'fromBackend') {
                    backLink = this.backUrl;
                }
                setTimeout(this.slideEvent, 500);
            },
            slideEvent(){
                navPos();
                this.$router.replace({'name': this.$route.name, params: {'id': this.items[this.mySwiper.activeIndex].id}});
                this.mySwiper.lazy.loadInSlide(+(this.mySwiper.activeIndex) + 1);
                this.mySwiper.lazy.loadInSlide(+(this.mySwiper.activeIndex) - 1);
            },
            backHelper(){
                this.$router.push({ path: backLink });
            },
        }
    }
</script>

<style scoped>

</style>